export default defineNuxtPlugin((nuxtApp) => {
    const shopCartStore = useShopCartStore()
    const categoriesStore = useCategoriesStore()
    const initSettingsStore = useDefaultSettingsStore()
    const { get: getInitSettings } = useOFetchCustom(
        "init-settings",
        true,
        true
    )

    if (import.meta.client) {
        try {
            shopCartStore.fetchShopCart()
            categoriesStore.getCategories()
            getInitSettings(undefined, {
                onSuccess(res) {
                    initSettingsStore.setSettings(res.data)
                },
            })
        } catch (error) {
            console.error(error)
        }
    }

    return {
        provide: {
            refreshEssentialData: () => {
                if (import.meta.client) {
                    shopCartStore.fetchShopCart()
                    categoriesStore.fetchCategories()
                    getInitSettings(undefined, {
                        onSuccess(res) {
                            initSettingsStore.setSettings(res.data)
                        },
                    })
                }
            },
            refreshSettingsData: () => {
                if (import.meta.client) {
                    getInitSettings(undefined, {
                        onSuccess(res) {
                            initSettingsStore.setSettings(res.data)
                        },
                    })
                }
            },
            refreshCategoriesData: () => {
                if (import.meta.client) {
                    categoriesStore.fetchCategories()
                }
            },
            refreshShopCartData: () => {
                if (import.meta.client) {
                    shopCartStore.fetchShopCart()
                }
            },
        },
    }
})
